import React from 'react';
import { ButtonIcon } from './Icons';

const Hero = () => {
  return (
    <div className="hero-container" id="hero">
      <div className="hero">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 col-md-12">
              <h1 style={{ color: '#f4f4f4', fontSize: '3.5rem', fontWeight: '700', lineHeight: '1.2' }}>
                Data-driven digital products that deliver
              </h1>
              <p style={{ color: '#f4f4f4', fontSize: '1.2rem', marginTop: '25px', lineHeight: '1.8', maxWidth: '600px', opacity: '0.9' }}>
                We build optimized websites with analytics at their core
              </p>
              <div style={{ marginTop: '35px', textAlign: 'left' }}>
                <a href="#contact" className="btn-theme">
                  Find out more
                  <ButtonIcon className="button-icon" size={20} />
                </a>
              </div>
            </div>
            <div className="col-lg-5 d-none d-lg-flex justify-content-center hero-illustration">
              <img 
                src="/assets/img/illustration/14.png" 
                alt="Hero Illustration" 
                style={{ transform: "scaleX(1)", maxWidth: '100%', height: 'auto' }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
